module.exports = __webpack_public_path__ + "img/hip.ebaf62f8.jpg";